<template>
  <div class="order-detail-contain">
    <el-tabs v-model="activeName" @tab-change="handleClick">
      <el-tab-pane label="收款单基本信息" name="first">
        <create-list @getCreateDetails="getCreateDetails"></create-list>
      </el-tab-pane>
      <el-tab-pane label="收款单详情信息" name="second" :disabled="secondAble">
        <createDetails
          ref="detailInfo"
          :createListInfo="createListInfo"
        ></createDetails>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { computed, ref } from "vue";
import createDetails from "./createDetails.vue";
import createList from "./createList.vue";
import { useRoute } from "vue-router";
export default {
  name: "createFinanceCollection",
  components: {
    createDetails,
    createList,
  },
  setup() {
    const is_collection_details_id = ref("");
    const detailInfo = ref(null);
    const route = ref(useRoute());
    const secondAble = computed(() => {
      let flag =
        route.value.query.arrData[0] == "udt" || is_collection_details_id.value;
      return !flag;
    });
    const createListInfo = ref(null);
    const activeName = ref("first");
    const handleClick = (TabPanelName) => {
      if (TabPanelName == "second") {
        detailInfo.value.getCollectionDetails();
      }
    };
    const getCreateDetails = (val) => {
      const obj = detailInfo.value;
      is_collection_details_id.value = val.list_id;
      obj.list_id = val.list_id;
      obj.list_no = val.list_no;
      activeName.value = "second";
      obj.getCollectionDetails();
    };
    return {
      activeName,
      getCreateDetails,
      createListInfo,
      secondAble,
      detailInfo,
      handleClick,
    };
  },
};
</script>
<style scoped>
.order-detail-contain {
  padding: 20px 0;
}
</style>
